import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1f713eda"), n = n(), _popScopeId(), n);
const _hoisted_1 = { key: 0 };
const _hoisted_2 = { class: "conversation__media-container" };
const _hoisted_3 = { key: 0 };
const _hoisted_4 = { class: "conversation__media-content" };
const _hoisted_5 = ["src", "alt", "title"];
const _hoisted_6 = ["title"];
const _hoisted_7 = {
    key: 1,
    class: "conversation__media-content"
};
const _hoisted_8 = ["src"];
const _hoisted_9 = { key: 2 };
const _hoisted_10 = {
    class: "conversation__media-file cursor-pointer",
    style: { "width": "100%" }
};
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("hr", { class: "conversation__media-separator" }, null, -1));
const _hoisted_12 = {
    key: 3,
    class: "conversation__media-caption"
};
const _hoisted_13 = {
    key: 1,
    class: "conversation__media-container"
};
import ParentService from '../services/parent.service';
import { Download } from 'lucide-vue-next';
import { ConversationMediaType } from "@/types/ConversationTypes";
import { ref, computed, watch } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ConversationItemMedia',
    props: ['media', 'caption'],
    emits: ['requestDownload', 'mediaLoaded'],
    setup(__props, { emit: emits }) {
        const props = __props;
        const isLoading = ref(false);
        const isLoaded = computed(() => props.media.content.url);
        const isImage = computed(() => props.media.content.type === ConversationMediaType.IMAGE);
        const isVideo = computed(() => props.media.content.type === ConversationMediaType.VIDEO);
        const isFile = computed(() => props.media.content.type === ConversationMediaType.FILE);
        const mediaUrl = computed(() => props.media.content.url);
        const showMediaViewer = () => {
            ParentService.showMedia(props.media.content, props.media.content.type);
        };
        const downloadFile = () => {
            if (!mediaUrl.value) {
                isLoading.value = true;
                emits('requestDownload', props.media.content.id);
            }
            else {
                openAttachment();
            }
        };
        const openAttachment = () => {
            window.open(props.media.content.url);
        };
        const mediaLoaded = () => {
            emits('mediaLoaded', props.media.content.id);
        };
        watch(() => mediaUrl, () => {
            if (isFile.value) {
                isLoading.value = false;
                openAttachment();
            }
        });
        return (_ctx, _cache) => {
            const _component_BaseSpinner = _resolveComponent("BaseSpinner");
            const _directive_safe_html = _resolveDirective("safe-html");
            return (_unref(isLoaded) || _unref(isFile))
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        (_unref(isImage))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                _createElementVNode("div", _hoisted_4, [
                                    _createElementVNode("img", {
                                        class: "conversation__media-image",
                                        src: __props.media.content.url,
                                        alt: __props.media.content.url,
                                        onLoad: mediaLoaded,
                                        onClick: showMediaViewer,
                                        title: __props.media.content.name
                                    }, null, 40, _hoisted_5)
                                ]),
                                (__props.media.content.name !== 'filename')
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 0,
                                        class: "conversation__media-name show-text-ellipsis",
                                        title: __props.media.content.name
                                    }, _toDisplayString(__props.media.content.name), 9, _hoisted_6))
                                    : _createCommentVNode("", true)
                            ]))
                            : (_unref(isVideo))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                    _createElementVNode("video", {
                                        class: "conversation__media-video",
                                        src: __props.media.content.url,
                                        onLoad: mediaLoaded,
                                        controls: ""
                                    }, null, 40, _hoisted_8)
                                ]))
                                : (_unref(isFile))
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                        _createElementVNode("div", _hoisted_10, [
                                            _withDirectives(_createElementVNode("div", null, [
                                                _createVNode(_component_BaseSpinner, {
                                                    size: "is-medium",
                                                    loading: !_unref(isLoaded),
                                                    delay: 0.1
                                                }, null, 8, ["loading", "delay"])
                                            ], 512), [
                                                [_vShow, isLoading.value]
                                            ]),
                                            _withDirectives(_createElementVNode("div", null, [
                                                _createVNode(_unref(Download), {
                                                    onClick: downloadFile,
                                                    size: "26",
                                                    color: "grey",
                                                    class: "conversation__media-file-icon"
                                                })
                                            ], 512), [
                                                [_vShow, !isLoading.value]
                                            ])
                                        ]),
                                        _hoisted_11
                                    ]))
                                    : _createCommentVNode("", true),
                        (__props.caption)
                            ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_12, null, 512)), [
                                [_directive_safe_html, __props.caption]
                            ])
                            : _createCommentVNode("", true)
                    ])
                ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createVNode(_component_BaseSpinner, {
                        size: "is-medium",
                        loading: !_unref(isLoaded)
                    }, null, 8, ["loading"])
                ]));
        };
    }
});
